import React from 'react';
import Checkout from "../pages/Checkout/Checkout";
import { LineItem } from "../LineItems/LineItem"
import { cartUpdateEventListener, getLineitems } from "../../utils/kit/modules/shoppingCart";


/**
 * Component responsible for retrieving the logged in user and session storage
 * and providing the CheckoutPage component with the correct line items and configurations.
 */

const CheckoutRouter = () => 
{
    const [ cart, setCart] = React.useState<LineItem[]>(getLineitems() ?? []);

    React.useEffect(() => {
        const handleCartUpdateChange = (event?: Event) => 
        {
            setCart(getLineitems() ?? []);
        }

        handleCartUpdateChange();

        return cartUpdateEventListener(handleCartUpdateChange);
        
    }, []);
   
    return(<Checkout
            lineItems={cart}
        />)
}

export default CheckoutRouter;